var Shopify=Shopify||{};function slickVeritcal(){$(".media-slick-slider  .thumbnail-list").length>0&&$(".thumbnail-list").not(".slick-initialized").slick({vertical:!0,verticalSwiping:!0,slidesToShow:4,slidesToScroll:1})}function slickHorizontal(){$(".media-slick-slider  .thumbnail-list").length>0&&$(".thumbnail-list").slick("unslick")}Shopify.money_format="${{amount}}",Shopify.formatMoney=function(t,e){"string"==typeof t&&(t=t.replace(".",""));var s="",i=/\{\{\s*(\w+)\s*\}\}/,o=e||this.money_format;function a(t,e){return void 0===t?e:t}function n(t,e,s,i){if(e=a(e,2),s=a(s,","),i=a(i,"."),isNaN(t)||null==t)return 0;var o=(t=(t/100).toFixed(e)).split(".");return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+s)+(o[1]?i+o[1]:"")}switch(o.match(i)[1]){case"amount":s=n(t,2);break;case"amount_no_decimals":s=n(t,0);break;case"amount_with_comma_separator":s=n(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":s=n(t,0,".",",")}return o.replace(i,s)},$("#preloader").length>0&&$(window).on("load",function(){$("#preloader").delay(1e3).fadeOut(1e3,function(){$(".preloader-overflow").length>0&&$("body").removeClass("preloader-overflow")})}),$(document).ready(function(){$(this).width()>=769?slickVeritcal():slickHorizontal()}),$(window).on("resize",function(){$(this).width()>=769?slickVeritcal():slickHorizontal()}),$(window).scroll(function(){$(window).width()>"1024"&&($(window).scrollTop()>=500?$(".sticky-bar").addClass("active"):$(".sticky-bar").removeClass("active"))}),$(window).scroll(function(){$(window).width()<"1024"&&($(window).scrollTop()>=900?$(".sticky-bar").addClass("active"):$(".sticky-bar").removeClass("active"))}),$(document).ready(function(){$("#recently").click(function(){$("#recently-viewed-products").slideToggle(500)})});var afterInfiniteLoaded=function(){$(".loading-image").removeClass("loading-image").addClass("loaded-image")};if($(".pagination-method-loadmore_btn").length>0)var AjaxMethod="click";else AjaxMethod="scroll";if($(".collection #AjaxinatePagination").length>0)var endlessScroll=new Ajaxinate({container:".AjaxinateContainer",pagination:"#AjaxinatePagination",method:AjaxMethod,offset:0,callback:afterInfiniteLoaded});function InitCustomFunctions(){if($(".facet-checkbox input:checkbox").each(function(){$(this).is(":checked")&&$(this).parent(".facet-checkbox").addClass("active")}),$(".toggleFilter").length>0){const t=document.querySelector(".toggleFilter"),e=document.querySelector(".facets-vertical"),s=document.querySelector(".close-sidebar");t.addEventListener("click",()=>{t.classList.toggle("active"),e.classList.toggle("open"),$("body").addClass("overflow-hidden"),$("body").addClass("filter-clicked")}),s.addEventListener("click",()=>{t.classList.remove("active"),e.classList.remove("open"),$("body").removeClass("overflow-hidden"),$("body").removeClass("filter-clicked")})}if($(".show-grouped__variant").length>0&&$('input:radio[name="Color"]').click(function(){const t=$(this).val();$(this).closest("fieldset").find(".form__label span").text(t),$('input:radio[name="Color"]').next(".swatch-element").removeClass("clicked"),$(this).next(".swatch-element").addClass("clicked"),$(".slick-list").addClass("height_fix"),$(".thumbnail-list__item").each(function(){const e=$(this).find("img").attr("alt");t==e?($(this).addClass("show"),$(this).removeClass("hidden")):($(this).addClass("hidden"),$(this).removeClass("show"))})}),$(document).on("click",".color-values a",function(){$(this).hasClass("active")?$(this).closest(".variant-option-color").find(".color-values a").removeClass("active"):($(this).closest(".variant-option-color").find(".color-values a").removeClass("active"),$(this).addClass("active"))}),$(document).on("click",".size-values a",function(){$(this).hasClass("active")?($(".size-values a").removeClass("active"),$(this).parents(".products").find(".variant-option-size .size-values").removeClass("active")):($(".size-values a").removeClass("active"),$(this).addClass("active"),$(this).parents(".products").find(".variant-option-size .size-values").removeClass("active"))}),$("body").on("click",".color-values-plus a",function(t){$(this).parents(".variant-option-color").find(".show-on-click").css("display","flex"),$(this).parents(".color-values-plus").css("display","none"),t.preventDefault()}),$("body").on("click",".swatch-element.color",function(){$(this).next("label").find("i")}),$("body").on("click",".swatch span",function(){$(this).parents(".card-wrapper").find(".card__inner .motion-reduce").attr("srcset",$(this).data("image"));if($(this).parents(".card-wrapper").find(".card__inner .motion-reduce").attr("srcset",$(this).data("image")),$(this).parents(".swatch").hasClass("color")){const e=$(this).data("id");$(this).parents(".product-grid").find(".variant-push").val(e);var t=$(this).data("variant-item");$(this).parents(".product-grid").find(".variant-option-size .size-values").removeClass("active"),$(this).parents(".product-grid").find(".variant-option-size .swatch").each(function(){var e=$(this).find("span").data("variant-title");e=e.split("/"),e=$.map(e,$.trim),e=$.map(e,function(t){return t.toLowerCase()}),e=$.map(e,function(t){return t.replace(/ /g,"-")}),$.inArray(t,e)>=0&&$(this).parent(".size-values").toggleClass("active")})}if($(this).parents(".swatch").hasClass("size")){var e=$(this).data("id");$(this).parents(".product-grid").find(".variant-push").val(e)}}),$(".custom-product-grid li").click(function(){var t=$(this).data("cols"),e="align-"+(e=$(this).data("val"))+"-column";$(".custom-product-grid li").removeClass("active"),$(this).addClass("active"),$("ul#product-grid").removeClass("list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column").addClass(t+" "+e)}),$(".filter-buttons").length>0){if(document.querySelector(".grid-view-button").classList.contains("layout-mode")){const t=document.querySelector(".list-view-button"),e=document.querySelector(".grid-view-button"),s=document.querySelector("ul.view-mode"),i=document.querySelector(".custom-product-grid");t.onclick=function(){t.classList.add("active"),e.classList.remove("active"),s.classList.remove("grid-view-filter"),s.classList.add("list-view-filter"),i.classList.add("hidden")},e.onclick=function(){t.classList.remove("active"),e.classList.add("active"),s.classList.remove("list-view-filter"),s.classList.add("grid-view-filter"),i.classList.remove("hidden")}}}if($("#swiper-sidebar-carousel").length>0)new Swiper("#swiper-sidebar-carousel",{navigation:{nextEl:"#swiper-sidebar-next",prevEl:"#swiper-sidebar-prev"}});setTimeout(function(){$(".loading-image").removeClass("loading-image").addClass("loaded-image")},2e3);const t=document.querySelectorAll('.dt-sort__container input[name="sort_by"]'),e=document.querySelector(".dt-sort__container .facets__summary-label");var s;for(const i of t)i.checked&&(s=i.getAttribute("data-value"),console.log(s),e.innerHTML=s);$("#dT_TopStickySearchBtn").click(function(t){t.preventDefault(),$("#dT_top-sticky").addClass("search-show"),$("#dT_top-sticky .search-modal").css("opacity","1"),$("body").addClass("search-overlay-open")}),$(".dT_TopStickySearchCloseBtn").click(function(t){t.preventDefault(),$("#dT_top-sticky").removeClass("search-show"),$("#dT_top-sticky .search-modal").css("opacity","0"),$("body").removeClass("search-overlay-open")})}function loadedBg(){window.onload=function(){setTimeout(function(){$(".loading-image").removeClass("loading-image").addClass("loaded-image")},3e3)}}function closeDrawerMenu(){document.querySelector("body").classList.remove("overflow-hidden-tablet")}function hotSpot(){$(window).width()>767&&jQuery(function(t){t(".dt-sc-hotspot-item").each(function(){var e=t(this).find(".dt-sc-hotspot-popup");e.click(function(t){t.stopPropagation()}),t(this).find("a.dt-sc-hotspot-marker").click(function(e){e.preventDefault(),e.stopPropagation(),t(this).parent().parent().addClass("this-hotspot-in-active"),t(this).hasClass("clicked")?(t(this).removeClass("clicked"),t(".this-hotspot-in-active").find("a.dt-sc-hotspot-marker").css("opacity","0"),t(this).css("opacity","1"),t(".dt-sc-hotspot-item").removeClass("open"),t("a.dt-sc-hotspot-marker").css("opacity","1")):(t(this).addClass("clicked"),t(".this-hotspot-in-active").find("a.dt-sc-hotspot-marker").css("opacity","0"),t(this).css("opacity","1"),t(this).parent().addClass("open"),t(this).next(".dt-sc-hotspot-popup").toggleClass("dt-sc-popup-open"),t(this).parent().siblings().children(".dt-sc-hotspot-popup").removeClass("dt-sc-popup-open"))}),t(document).click(function(){t(".dt-sc-hotspot-wrapper").removeClass("this-hotspot-in-active"),e.removeClass("dt-sc-popup-open"),t(".dt-sc-hotspot-item").removeClass("open"),t("a.dt-sc-hotspot-marker").removeClass("clicked"),t("a.dt-sc-hotspot-marker").css("opacity","1")})})}),$(window).width()<768&&($(".dt-sc-hotspot-popup").addClass("mfp-hide"),$(".dt-sc-hotspot-marker").each(function(){$(this).magnificPopup({type:"inline",closeOnBgClick:!0,closeBtnInside:!1,showCloseBtn:!0})}))}InitCustomFunctions(),$("ul.custom-select").on("click","li:not(.init)",function(){var t=$(this).data("option-value");$(this).parents(".fbt-product__meta").find(".selectVariant option").attr("selected",!1),$(this).parents(".fbt-product__meta").find(".selectVariant option[value="+t+"]").attr("selected","selected").trigger("change")}),$("ul.custom-select").on("click",".init",function(){$(this).closest("ul.custom-select").children("li:not(.init)").toggle()}),$("ul.custom-select").on("click","li:not(.init)",function(){$(this).parent().children("li:not(.init)").removeClass("selected"),$(this).addClass("selected"),$(this).parent().children(".init").html($(this).html()),$(this).parent().children(".init").removeClass("li-unselected"),$(this).parent().children("li:not(.init)").toggle(),$("ul.custom-select li.init").hasClass("li-unselected")?$("#add-frequently-bought").prop("disabled",!0):$("#add-frequently-bought").prop("disabled",!1)}),loadedBg(),jQuery(function(){jQuery().on("click",function(){jQuery("iframe").contents().find("video").each(function(){this.currentTime=0,this.pause()})})}),document.querySelector(".header-drawer__close").addEventListener("click",closeDrawerMenu),setTimeout(function(){$("#AccessibleNav .sub-menu-block").show()},1e3),$(document).ready(function(){setTimeout(function(){document.getElementById("MainContent").classList.remove("placeholder-shadow-blocks")},1500)}),$(function(){$(".acc__title").click(function(t){var e=$(this).closest(".dt-sc-tabs-content");$(this).closest("dt-sc-tabs-content").not(e).slideUp(),$(this).hasClass("active")?$(this).removeClass("active"):($(this).closest("dt-sc-tabs-content.active").removeClass("active"),$(this).addClass("active")),e.stop(!1,!0).slideToggle(),t.preventDefault()})}),$(document).ready(function(){$(".tablinks").click(function(){$(".dt-sc-tabs-content").removeClass("tab-active-content"),$(".dt-sc-tabs-content[data-id='"+$(this).attr("data-id")+"']").addClass("tab-active-content"),$(".tablinks").removeClass("active-tab"),$(this).addClass("active-tab")})}),$(document).ready(function(){hotSpot()}),$(window).on("resize",function(){hotSpot()}),document.querySelector(".main-product-template")&&$(window).width()<768&&document.addEventListener("click",function(t){if(t.target.closest(".global-media-settings.active")){const e=t.target;e.dataset.zoomInit||(e.dataset.zoomInit="true",e.dataset.zoomed="false",e.style.transition="transform 0.3s ease",e.style.cursor="zoom-in");const s=e.getBoundingClientRect(),i=(t.clientX-s.left)/s.width*100,o=(t.clientY-s.top)/s.height*100;"false"===e.dataset.zoomed?(e.style.transformOrigin=`${i}% ${o}%`,e.style.transform="scale(2)",e.style.cursor="zoom-out",e.dataset.zoomed="true"):(e.style.transformOrigin="center center",e.style.transform="scale(1)",e.style.cursor="zoom-in",e.dataset.zoomed="false")}});
// var Shopify = Shopify || {};
// // ---------------------------------------------------------------------------
// // Money format handler
// // ---------------------------------------------------------------------------
// Shopify.money_format = "${{amount}}";
// Shopify.formatMoney = function (cents, format) {
//   if (typeof cents == "string") {
//     cents = cents.replace(".", "");
//   }
//   var value = "";
//   var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   var formatString = format || this.money_format;

//   function defaultOption(opt, def) {
//     return typeof opt == "undefined" ? def : opt;
//   }

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     precision = defaultOption(precision, 2);
//     thousands = defaultOption(thousands, ",");
//     decimal = defaultOption(decimal, ".");

//     if (isNaN(number) || number == null) {
//       return 0;
//     }

//     number = (number / 100.0).toFixed(precision);

//     var parts = number.split("."),
//       dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
//       cents = parts[1] ? decimal + parts[1] : "";

//     return dollars + cents;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case "amount":
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case "amount_no_decimals":
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case "amount_with_comma_separator":
//       value = formatWithDelimiters(cents, 2, ".", ",");
//       break;
//     case "amount_no_decimals_with_comma_separator":
//       value = formatWithDelimiters(cents, 0, ".", ",");
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// };

// if ($("#preloader").length > 0) {
//   $(window).on("load", function () {
//     $("#preloader")
//       .delay(1000)
//       .fadeOut(1000, function () {
//         if ($(".preloader-overflow").length > 0) {
//           $("body").removeClass("preloader-overflow");
//         }
//       });
//   });
// }
 
// $(document).ready(function () {
//     var Dwin = $(this); 
//     if (Dwin.width() >= 769) {
//       slickVeritcal();
//     }
//   else
//     {
//       slickHorizontal();
//     }    
// });
 
// $(window).on('resize', function(){
//     var win = $(this); 
//     if (win.width() >= 769) {
//       slickVeritcal();
//     }
//   else
//     {
//       slickHorizontal();
//     }    
// });

// function slickVeritcal() {     
//   if ($(".media-slick-slider  .thumbnail-list").length > 0) {
//   $(".thumbnail-list").not(".slick-initialized").slick({
//     vertical: true,
//     verticalSwiping: true,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//   });

//   }  
// }
// function slickHorizontal() {  
//     if ($(".media-slick-slider  .thumbnail-list").length > 0) {
//     $(".thumbnail-list").slick("unslick");        
//     }    
// }

// $(window).scroll(function () {
//   if ($(window).width() > "1024") {
//     if ($(window).scrollTop() >= 500) {      
//       $(".sticky-bar").addClass("active");
//     } else {       
//       $(".sticky-bar").removeClass("active");
//     }
//   }
// });

// $(window).scroll(function () {
//   if ($(window).width() < "1024") {
//     if ($(window).scrollTop() >= 900) {      
//       $(".sticky-bar").addClass("active");
//     } else {       
//       $(".sticky-bar").removeClass("active");
//     }
//   }
// });

// $(document).ready(function () {
//   $("#recently").click(function () {
//     $("#recently-viewed-products").slideToggle(500);
//   });
// });

// var afterInfiniteLoaded = function afterInfiniteLoaded() {
//   $(".loading-image").removeClass("loading-image").addClass("loaded-image");
// };
// if ($(".pagination-method-loadmore_btn").length > 0) {
//   var AjaxMethod = "click";
// } else {
//   var AjaxMethod = "scroll";
// }
// if ($(".collection #AjaxinatePagination").length > 0) {
//   var endlessScroll = new Ajaxinate({
//     container: ".AjaxinateContainer",
//     pagination: "#AjaxinatePagination",
//     method: AjaxMethod,
//     offset: 0,
//     callback: afterInfiniteLoaded,
//   });
// }

// InitCustomFunctions();
// function InitCustomFunctions() {
//   $('.facet-checkbox input:checkbox').each(function () {
//   if($(this).is(':checked')){
//        $(this).parent('.facet-checkbox').addClass('active');
//     }     
//   });
  

  
//   if ($(".toggleFilter").length > 0) {
//     const filter = document.querySelector(".toggleFilter");
//     const sidebar = document.querySelector(".facets-vertical");
//     const closeDiv = document.querySelector(".close-sidebar");

//     filter.addEventListener("click", () => {
//       filter.classList.toggle("active");
//       sidebar.classList.toggle("open");
//       $("body").addClass("overflow-hidden");
//       $("body").addClass("filter-clicked");
//     });

//     closeDiv.addEventListener("click", () => {
//       filter.classList.remove("active");
//       sidebar.classList.remove("open");
//       $("body").removeClass("overflow-hidden");
//       $("body").removeClass("filter-clicked");
//     });
//   }

//   //product page color variant to select thumbnail img change color_variants
//   if ($(".show-grouped__variant").length > 0) {
//     $('input:radio[name="Color"]').click(function () {
//       const cvariant = $(this).val();
//       $(this).closest('fieldset').find('.form__label span').text(cvariant);
//       $('input:radio[name="Color"]')
//         .next(".swatch-element")
//         .removeClass("clicked");
//       $(this).next(".swatch-element").addClass("clicked");
//       $(".slick-list").addClass("height_fix");
//       $(".thumbnail-list__item").each(function () {
//         const variant_val = $(this).find("img").attr("alt");
//         if (cvariant == variant_val) {
//           $(this).addClass("show");
//           $(this).removeClass("hidden");
//         } else {
//           $(this).addClass("hidden");
//           $(this).removeClass("show");
//         }
//       });
//     });
//   }

//   //     Item swatch trigger start
//   $(document).on("click", ".color-values a", function () {
//     if ($(this).hasClass("active")) {
//       $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
//     } else {
//       $(this).closest('.variant-option-color').find('.color-values a').removeClass("active");
//       $(this).addClass("active");
//     }
//   });

//   $(document).on("click", ".size-values a", function () {
//     if ($(this).hasClass("active")) {
//       $(".size-values a").removeClass("active");
//       $(this)
//         .parents(".products")
//         .find(".variant-option-size .size-values")
//         .removeClass("active");
//     } else {
//       $(".size-values a").removeClass("active");
//       $(this).addClass("active");
//       $(this)
//         .parents(".products")
//         .find(".variant-option-size .size-values")
//         .removeClass("active");
//     }
//   });
//   $("body").on("click", ".color-values-plus a", function (e) {
//     $(this)
//       .parents(".variant-option-color")
//       .find(".show-on-click")
//       .css("display", "flex");
//     $(this).parents(".color-values-plus").css("display", "none");
//     e.preventDefault();
//   });

//   $("body").on("click", ".swatch-element.color", function () {
//     $(this).next("label").find("i");
//   });
//   $("body").on("click", ".swatch span", function () {
//     var featuredMedia = $(this)
//       .parents(".card-wrapper")
//       .find(".card__inner .motion-reduce")
//       .attr("srcset", $(this).data("image"));
//     $(this)
//       .parents(".card-wrapper")
//       .find(".card__inner .motion-reduce")
//       .attr("srcset", $(this).data("image"));

//     if ($(this).parents(".swatch").hasClass("color")) {
//       const variant = $(this).data("id");
//       $(this).parents(".product-grid").find(".variant-push").val(variant);

//       var swatch_item = $(this).data("variant-item");

//       $(this)
//         .parents(".product-grid")
//         .find(".variant-option-size .size-values")
//         .removeClass("active");

//       $(this)
//         .parents(".product-grid")
//         .find(".variant-option-size .swatch")
//         .each(function () {
//           var swatch_size_vars = $(this).find("span").data("variant-title");
//           swatch_size_vars = swatch_size_vars.split("/");
//           swatch_size_vars = $.map(swatch_size_vars, $.trim);
//           swatch_size_vars = $.map(swatch_size_vars, function (n) {
//             return n.toLowerCase();
//           });
//           swatch_size_vars = $.map(swatch_size_vars, function (n) {
//             return n.replace(/ /g, "-");
//           });

//           if ($.inArray(swatch_item, swatch_size_vars) >= 0) {
//             $(this).parent(".size-values").toggleClass("active");
//           }
//         });
//     }

//     if ($(this).parents(".swatch").hasClass("size")) {
//       var variant = $(this).data("id");
//       $(this).parents(".product-grid").find(".variant-push").val(variant);
//     }
//   });

//   //     Item swatch trigger end
//   $(".custom-product-grid li").click(function () {
//     var classNames ="list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
//     var getCols = $(this).data("cols");
//     var getVal = $(this).data("val");
//     var getVal = "align-"+getVal+"-column";    
//     $(".custom-product-grid li").removeClass("active");
//     $(this).addClass("active");
//     $("ul#product-grid").removeClass(classNames).addClass(getCols+" "+getVal);
//   });
//   if ($(".filter-buttons").length > 0) {
//     const viewExists = document.querySelector(".grid-view-button");
//     if (viewExists.classList.contains("layout-mode")) {
//       const listViewButton = document.querySelector(".list-view-button");
//       const gridViewButton = document.querySelector(".grid-view-button");
//       const list = document.querySelector("ul.view-mode");
//       const gridviewlist = document.querySelector(".custom-product-grid");

//       listViewButton.onclick = function () {
//         listViewButton.classList.add("active");
//         gridViewButton.classList.remove("active");
//         list.classList.remove("grid-view-filter");
//         list.classList.add("list-view-filter");
//         gridviewlist.classList.add("hidden");
//       };

//       gridViewButton.onclick = function () {
//         listViewButton.classList.remove("active");
//         gridViewButton.classList.add("active");
//         list.classList.remove("list-view-filter");
//         list.classList.add("grid-view-filter");
//         gridviewlist.classList.remove("hidden");
//       };
//     }
//   }
//   if ($("#swiper-sidebar-carousel").length > 0) {
//     var swiper = new Swiper("#swiper-sidebar-carousel", {
//       navigation: {
//         nextEl: "#swiper-sidebar-next",
//         prevEl: "#swiper-sidebar-prev",
//       },
//     });
//   }

//   setTimeout(function () {
//     $(".loading-image").removeClass("loading-image").addClass("loaded-image");
//   }, 2000);

//   const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
//   const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
//   var selectedRadioButton;
//   for (const radioButton of radioButtons) {
//     if (radioButton.checked) {
//       selectedRadioButton = radioButton.getAttribute("data-value");
//       console.log(selectedRadioButton);
//       optionSummary.innerHTML = selectedRadioButton;    
//     }
//   }

//   $("#dT_TopStickySearchBtn").click(function (ev) {
//   ev.preventDefault();
//   $("#dT_top-sticky").addClass("search-show");
//   $("#dT_top-sticky .search-modal").css("opacity", "1");
//   $("body").addClass("search-overlay-open");
// });

// $(".dT_TopStickySearchCloseBtn").click(function (ev) {
//   ev.preventDefault();
//   $("#dT_top-sticky").removeClass("search-show");
//   $("#dT_top-sticky .search-modal").css("opacity", "0");
//   $("body").removeClass("search-overlay-open");
// });
  
// }


// //FBT ul li select box
// $("ul.custom-select").on("click", "li:not(.init)", function () {
//   var selectedVal = $(this).data("option-value");
//   // console.log(selectedVal);
//   $(this)
//     .parents(".fbt-product__meta")
//     .find(".selectVariant option")
//     .attr("selected", false);
//   $(this)
//     .parents(".fbt-product__meta")
//     .find(".selectVariant option[value=" + selectedVal + "]")
//     .attr("selected", "selected")
//     .trigger("change");
// });

// $("ul.custom-select").on("click", ".init", function () {
//   $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
// });

// $("ul.custom-select").on("click", "li:not(.init)", function () {
//   $(this).parent().children("li:not(.init)").removeClass("selected");
//   $(this).addClass("selected");
//   $(this).parent().children(".init").html($(this).html());
//   $(this).parent().children(".init").removeClass("li-unselected");
//   $(this).parent().children("li:not(.init)").toggle();
//   if ($("ul.custom-select li.init").hasClass("li-unselected")) {
//     $("#add-frequently-bought").prop("disabled", true);
//   } else {
//     $("#add-frequently-bought").prop("disabled", false);
//   }
// });
// loadedBg();
// function loadedBg() {
//   window.onload = function () {
//     setTimeout(function () {
//       $(".loading-image").removeClass("loading-image").addClass("loaded-image");
//     }, 3000);
//   };
// }

// jQuery(function () {
//   jQuery().on("click", function () {
//     jQuery("iframe")
//       .contents()
//       .find("video")
//       .each(function () {
//         this.currentTime = 0;
//         this.pause();
//       });
//   });
// });


// document.querySelector(".header-drawer__close").addEventListener("click", closeDrawerMenu);
// function closeDrawerMenu() {
//   document.querySelector("body").classList.remove("overflow-hidden-tablet");
// }

// setTimeout(function () {
//   $("#AccessibleNav .sub-menu-block").show();
// }, 1000);



// $(document).ready(function () {
//   setTimeout(function () {
//  document.getElementById("MainContent").classList.remove("placeholder-shadow-blocks");
//     }, 1500);
// });



// $(function() {
//   $('.acc__title').click(function(j) {    
//     var dropDown = $(this).closest('.dt-sc-tabs-content');
//     $(this).closest('dt-sc-tabs-content').not(dropDown).slideUp();    
//     if ($(this).hasClass('active')) {
//       $(this).removeClass('active');
//     } else {
//       $(this).closest('dt-sc-tabs-content.active').removeClass('active');
//       $(this).addClass('active');
//     }    
//     dropDown.stop(false, true).slideToggle();
//     j.preventDefault();
//   });
// });


// $(document).ready(function(){ 
//     $('.tablinks').click(function(){  
//       $(".dt-sc-tabs-content").removeClass('tab-active-content');
//       $(".dt-sc-tabs-content[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active-content");
//       $(".tablinks").removeClass('active-tab');     
//       $(this).addClass('active-tab');
//      });
// });


// $(document).ready(function () {
//   hotSpot();
// });
// $(window).on("resize", function () {
//   hotSpot();
// });
// function hotSpot() {
//     if($(window).width() > 767) 
//     {     
//       jQuery(function($) {
//        $('.dt-sc-hotspot-item').each(function () {
//         var pop = $(this).find('.dt-sc-hotspot-popup');
//         pop.click(function(e) {
//           e.stopPropagation();
//         });

//         $(this).find('a.dt-sc-hotspot-marker').click(function(e) {
//           e.preventDefault();
//           e.stopPropagation();        
//           // $(this).parent().addClass('open');          
//           // $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
//           // $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');

//           $(this).parent().parent().addClass('this-hotspot-in-active');
//           // For icons disable 
//           if ($(this).hasClass("clicked")) {
//           $(this).removeClass("clicked");     
//           $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity','0');  
//           $(this).css('opacity','1');   
//           $('.dt-sc-hotspot-item').removeClass('open');          
//           $('a.dt-sc-hotspot-marker').css('opacity','1'); 
//           }
//           else
//           {
//           $(this).addClass("clicked");               
//           $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css('opacity','0');  
//           $(this).css('opacity','1');     
//           $(this).parent().addClass('open');          
//           $(this).next('.dt-sc-hotspot-popup').toggleClass('dt-sc-popup-open');
//           $(this).parent().siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
//             }

//           // Disable End
          
//         });

//         $(document).click(function() {
//           $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
//           pop.removeClass('dt-sc-popup-open');
//           $('.dt-sc-hotspot-item').removeClass('open');
//           $('a.dt-sc-hotspot-marker').removeClass('clicked');
//           $('a.dt-sc-hotspot-marker').css('opacity','1'); 
//         });              
//       });
//   });
//     }  

//    if($(window).width() < 768) {     
//       $('.dt-sc-hotspot-popup').addClass('mfp-hide');
//       $('.dt-sc-hotspot-marker').each(function() {
//         $(this).magnificPopup({       
//         type: 'inline',
//         closeOnBgClick: true,
//         closeBtnInside: false,
//         showCloseBtn: true
//         });
//       });        
//     }    
// }

// if(document.querySelector('.main-product-template') && $(window).width() < 768){
//   document.addEventListener("click", function (e) {

//     // product image click thi modal open thay pachhi
//     if (e.target.closest(".global-media-settings.active")) {
//       const media = e.target;
//       // first time variables set
//       if (!media.dataset.zoomInit) {
//         media.dataset.zoomInit = "true";
//         media.dataset.zoomed = "false";

//         media.style.transition = "transform 0.3s ease";
//         media.style.cursor = "zoom-in";
//       }

//       const rect = media.getBoundingClientRect();

//       // click position
//       const x = ((e.clientX - rect.left) / rect.width) * 100;
//       const y = ((e.clientY - rect.top) / rect.height) * 100;

//       // toggle zoom
//       if (media.dataset.zoomed === "false") {

//         media.style.transformOrigin = `${x}% ${y}%`;
//         media.style.transform = "scale(2)";
//         media.style.cursor = "zoom-out";

//         media.dataset.zoomed = "true";

//       } else {

//         media.style.transformOrigin = "center center";
//         media.style.transform = "scale(1)";
//         media.style.cursor = "zoom-in";

//         media.dataset.zoomed = "false";
//       }
//     }
//   });
// }
 
console.clear();

var s = Splitting();
